import React, { useState, useEffect } from 'react';
import Modal from '../../Components/Modal';
import API from '../../Services/API';
import Loading from '../../Components/Loading';
import Button from '../../Components/Button/Button';
import { useToasts } from '../../Components/Toasts';
import Form, { Actions, Switch } from '../../Components/Form';

const Export = ({isOpen, setIsOpen}) => {
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const {showError} = useToasts();

    useEffect(() => {
        if (isOpen !== true) {
            setSubmitting(false);
            setDownloadUrl(null);
            return;
        }

    }, [isOpen]);

    const startExport = (data) => {
        setSubmitting(true);
        return API.get('/customers/export', data).then(res => {
            setDownloadUrl(res.downloadUrl);
        });
    }

    const download = () => {
        API.download(downloadUrl)
            .catch(err => showError(API.parseErrorResponse(err)))
            .then(() => setIsOpen(false));
    }

    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Export customers" dismissible>
        {!submitting && <Form data={{}} onSubmit={startExport}>
            <Switch label="Include archived customers" name="includeDeleted" />
            <Actions submit={{label: 'Export', icon: 'Download'}} />
        </Form>}

        {(!downloadUrl && submitting) && <>
            <Loading size="2x" center />
            <p className="text-center text-muted">Preparing download</p>
        </>}

        {downloadUrl && <p className="text-center">
            <Button theme="primary" icon="CloudArrowDown" label="Download" onClick={() => download()} />
        </p>}
    </Modal>
}

export default Export;